'use client'
import { useMemo } from 'react'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { usePathname } from '@/src/i18n/navigation'
import { getHeaderVisibility } from '@/src/utils/header/headerUtils'

export interface UseHeaderVisibilityReturn {
    showLangCurrDropdown: boolean
    showDeals: boolean
    shouldHideSignIn: boolean
    isOffersPage: boolean
    isItineraryPage: boolean
    isSignInPage: boolean
}

/** Hook for header visibility flags based on current pathname and variant */
export const useHeaderVisibility = (variant: 'flyin' | 'cleartrip' = 'flyin'): UseHeaderVisibilityReturn => {
    const pathname = usePathname()
    const isHeya = useIsHeya()

    const visibility = useMemo(() => {
        return getHeaderVisibility(pathname, variant, isHeya)
    }, [pathname, variant, isHeya])

    return visibility
}
